var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgReplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.333V.667L4.667 4 8 7.333V4.667c2.207 0 4 1.793 4 4 0 2.206-1.793 4-4 4s-4-1.794-4-4H2.667A5.332 5.332 0 0 0 8 14a5.332 5.332 0 0 0 5.333-5.333A5.332 5.332 0 0 0 8 3.333Z",
  fill: "currentColor"
})));

export default SvgReplay;